<template>
    <div class="device-type-manange relative">
        <el-page-header @back="goBack" :content="title"></el-page-header>
        <div class="buttons" :style="{position: button_position}">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col class="search" :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">消息内容：</span>
                <el-input v-model="content" placeholder="消息内容模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">发送者：</span>
                <el-select class="status" v-model="admin_id" placeholder="请选择发送者" style="width: 100%;max-width: none !important;">
                    <el-option
                            v-for="item in allRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <!--<div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="allPutMessage">群发</el-button>
        </div>-->

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="message_content" label="消息内容" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="发送者" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="create_date" label="发送时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'doctorEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">查看
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allRole: [
                    {
                        id: 1,
                        name: '超级管理员'
                    },
                    {
                        id: 2,
                        name: '后台管理员'
                    },
                ],
                user_id: '',
                user_name: '',
                mobile: '',
                role_type: '',
                content: '',
                title: '',
                admin_id: '',
                button_position: 'absolute',
                is_mobile: false,
            };
        },
        created() {
            if (isMobile()) {
                this.button_position = 'static'
                this.is_mobile = true
            }
        },
        mounted() {
            // 获取系统消息列表
            this.user_id = this.$route.params.user_id;
            this.user_name = this.$route.params.user_name;
            this.title = '系统消息（' + this.$route.params.user_name + '）';
            this.getList();
            localStorage.setItem('prev_page', 'system_message_user_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_ContentServices',
                    method: 'getUserMessageList',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: this.user_id,
                        content: this.content,
                        admin_id: this.admin_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.content = "";
                this.admin_id = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$alert(data.message_content, '消息内容', {}).catch((e)=>{});
            },

            // 导出数据
            allPutMessage() {
                this.$router.push({
                    name: "systemMessageAdd", params: {
                        type: 2
                    }
                });
            },


            // 返回上一页
            goBack() {
                window.history.go(-1);
            },


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
    .inputs .el-select.status .el-input {
        width: 100%;
    }
    .search .el-input {
        width: 100% !important;
    }
</style>
